import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  specialities: []
};

const slice = createSlice({
  name: 'speciality',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getSpecialitiesSuccess(state, action) {
      state.isLoading = false;
      state.specialities = action.payload;
    }
  }
});

export default slice.reducer;

export function getSpecialities() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/especialidad/all');
      dispatch(slice.actions.getSpecialitiesSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
